/**
 * State used in rendering MenuItemSwitch
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
